import { render } from "./ConfirmationModal.vue?vue&type=template&id=67c9a126&scoped=true"
import script from "./ConfirmationModal.vue?vue&type=script&lang=js"
export * from "./ConfirmationModal.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-67c9a126"

export default script